module.exports = __webpack_public_path__ + "img/finland-colorectal-cancer-male.292a5f41.png";